import Instance from "./instance";

  export const GetAllInfos = async () => {
    try {
      return await Instance.instanceToken.get(`/content/gs`);
    } catch (error) {
      return error;
    }
  };